import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpAction, IHttpConfig } from './http.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class HttpConfig implements IHttpConfig {
  abstract apiUrl: string;
  abstract trackerUrl: string;
  abstract useProxy: boolean;
  abstract httpHeaders: HttpHeaders;

  abstract buildRootEndpoint(): string;
  abstract buildRequestEndpoint(httpAction: IHttpAction): URL;

  constructor() {}
}
